import LoderLogo from '../images/whiteLogo.png';
import '../styles/loader.css';
const Loader=()=>{
    return(
        <div className="loader-wrapper">
      <div className="loader-component">
        <div className="loader-circle"></div>
        <div className="loader-circle"></div>
      </div>
      <div className="loader-img">
        <img src={LoderLogo} alt="vet-logo"/>
      </div>
    </div>
    )
}

export default Loader;